var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.0412C24 5.36082 18.6575 0 12 0C5.34247 0 0 5.36082 0 12.0412C0 18.0619 4.35616 23.0928 10.1096 24V15.5052H7.06849V12.0412H10.1096V9.40206C10.1096 6.35051 11.9178 4.70103 14.6301 4.70103C15.9452 4.70103 17.3425 4.94845 17.3425 4.94845V7.91753H15.863C14.3836 7.91753 13.8904 8.82474 13.8904 9.81443V12.0412H17.2603L16.7671 15.5052H13.9726V23.9175C19.6438 23.0928 24 18.0619 24 12.0412Z",
    fill: "#2D88FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb_icon.e1b80dd4.svg";
export { ForwardRef as ReactComponent };